export default "__VITE_ASSET__CwdqTaAp__"